import { render, staticRenderFns } from "./masterLevel.vue?vue&type=template&id=3a06e3e0&"
import script from "./masterLevel.vue?vue&type=script&lang=js&"
export * from "./masterLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QSeparator,QBtnGroup,QDialog,QSelect,QFile,QIcon,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QSeparator,QBtnGroup,QDialog,QSelect,QFile,QIcon,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
